export enum TimesheetDates {
  NUMBER_OF_MONTHS_CHANGED = 1,
  LAST_DAY_OF_MONTH = 0
}
